import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { InitialStateUserType } from '../typings/state'
import BottomNav from './Layout/BottomNav'
import Header from './Layout/Header/header'
interface IMainContainerProps {
  component: any;
  menu:string;
  user?: InitialStateUserType;
  path?: string;
  exact?: boolean;
  excludeBottom?: boolean
  noPadding?: boolean
  excludeHeader?: boolean
  headerTitle?: string
  showBreadcrumb?: boolean
  greetings?: boolean
}

const AuthedRoutesContainer: React.FC<IMainContainerProps> = (props) => {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(matchProps) =>
        !props?.user?.authenticated ? (
          <Redirect to="/" />
        ) : (
          <>
            {props?.excludeHeader ? null : (
              <Header
                title={props?.headerTitle}
                showBreadcrumb={props?.showBreadcrumb}
                greetings={props?.greetings}
              />
            )}
            <main
              className={`container mx-auto ${
                !props.noPadding ? "px-4 py-6" : "p-0"
              } space-y-6 max-w-screen-lg`}
            >
              <Component {...matchProps} />
            </main>
            {props?.excludeBottom ? null : <BottomNav menu={props.menu} />}
          </>
        )
      }
    />
  );
}

export const AuthedRoutes = connect(
  (state: any) => {
    return ({ user: state.user });
  },null
)(AuthedRoutesContainer);
